import { useState } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { deactivateOGEndpoint } from '../endpoints/deactivate-og/index.tsx';
import { useTransitioningStatusActions } from '../store/transitioning-status/index.tsx';
import messages from './messages.tsx';

export const useDeactivateOG = () => {
	const { deactivateOgApps } = useTransitioningStatusActions();
	const cloudId = useCloudId();
	const { showFlag } = useFlagsService();
	const [loading, setLoading] = useState(false);

	return {
		deactivate: () => {
			if (loading) return;
			setLoading(true);
			deactivateOGEndpoint(cloudId)
				.then(deactivateOgApps)
				.catch(() => {
					showFlag({
						type: 'error',
						title: messages.errorTitleNonFinal,
						description: messages.errorDescriptionNonFinal,
						actions: [
							{
								content: messages.errorActionNonFinal,
								href: '/jira/settings/personal/alert-notifications',
								target: '_blank',
							},
						],
						messageId:
							'eoc-changeboarding.services.use-deactivate-og.show-flag.error.eoc-changeboarding.services.use-mst-connection.show-flag',
						messageType: 'transactional',
					});
				})
				.finally(() => setLoading(false));
		},
		loading,
	};
};
